export const Features = {
  businessReportsEnabled: false,
  whatsNewContent: false,
  editClientProfileEnabled: false,
  notesAndObservationEnabled: false,
  foodDatabaseSourcesEnabled: false,
  ageEnabled: true,
  mealPlannerEnabled: true,
  clientListWorkplaceEnabled: false,
  clientListWPackageEnabled: false,
  sleepPatternSubtextEnabled: false,
  reminderTimeEnabled: false,
  clientProfileFieldsEnabled: false,
  assessmentSubtextEnabled: false,
  mealPlanRecommendedFieldsEnabled: false,
  exerciseTemplatesContentEnabled: false,
  programTemplatesContentEnabled: false,
  subscriptionDetailsFieldsEnabled: false,
  recipeDeleteEnabled: true,
  referralCodeEnabled: false,
  pdfMacronutrientsEnabled: true,
  reportIssueEnabled: false,
  waterIntakeGoalEnabled: true,
  appointmentsEnabled: true,
  appointmentPanelDescriptionEnabled: false,
  formsEnabled: true,
  duplicateFormEnabled: false,
  formsSendReminder: false,
  formsEditSentForm: false,
  formVideosEnabled: false,
  formCopyLinkEnabled: false,
  formSendToEmailEnabled: false,
  formCategoriesEnabled: false,
  schedulerCalendarViewEnabled: true,
  appointmentsCalendarViewEnabled: true,
};
